//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  async fetch() {
    await Promise.all([ 
      this.$store.dispatch('pagesStore/getPage', 'terms')
    ])
  },
  computed: {
    ...mapState({
      pages: ({ pagesStore: {pages} }) => pages
    }),
  },
  head() {
    return {
      title: this.pages.terms && this.pages.terms.seo ? this.pages.terms.seo.title : 'Algemene voorwaarden | Info | Meiden van Holland',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.terms && this.pages.terms.seo ? this.pages.terms.seo.title : 'Algemene voorwaarden | Info | Meiden van Holland' },
        { hid: 'og:title', name: 'og:title', content: this.pages.terms && this.pages.terms.seo ? this.pages.terms.seo.title : 'Algemene voorwaarden | Info | Meiden van Holland' },
        { hid: 'description', name: 'description', content: this.pages.terms && this.pages.terms.seo ? this.pages.terms.seo.description : 'Op deze pagina vind je de algemene voorwaarden die van toepassing zijn op het gebruik van de website van Meiden van Holland. Meiden van Holland is een initiatief van Blue Donkey Media B.V.'},
        { hid: 'og:description', name: 'og:description', content: this.pages.terms && this.pages.terms.seo ? this.pages.terms.seo.description : 'Op deze pagina vind je de algemene voorwaarden die van toepassing zijn op het gebruik van de website van Meiden van Holland. Meiden van Holland is een initiatief van Blue Donkey Media B.V.' },
        { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/info/algemene-voorwaarden' },
        { hid: 'keywords', name: 'keywords', content: this.pages.terms && this.pages.terms.seo ? this.pages.terms.seo.keywords : 'Algemene voorwaarden, voorwaarden' },
      ]
    }
  },
}
